<template>
  <div
    class="order_wrapper"
    :class="{
      native: !$nativeUtil.isDesktop(),
      'filter-loading': filterLoading
    }"
  >
    <!-- 订单详细信息页面 -->
    <van-nav-bar :title="orderTitle" @click-left="$utils.goBack()">
      <template #left>
        <span class="icon-left"></span>
      </template>
      <template v-if="$condition.isOrderStatus_success(orderStatus)" #right>
        <span @click="toResult(orderObj.id)" class="nav_icon icon-print"></span>
      </template>
    </van-nav-bar>
    <div class="order_box" ref="orderList">
      <!-- 信息列表 -->
      <div class="order_list">
        <div class="order_item">
          <div class="item_label">订单编号</div>
          <div class="item_content">{{ orderObj.id }}</div>
        </div>

        <div class="order_item">
          <div class="item_label">车场名称</div>
          <div class="item_content">{{ orderObj.parkingName }}</div>
        </div>
        <!-- <div class="order_item">
          <div class="item_label">岗位名称</div>
          <div class="item_content">科韵社区</div>
        </div>-->
        <div class="order_item">
          <div class="item_label">车位号</div>
          <div class="item_content">
            <span ref="parkingNumber"></span>
            <transition tag="div" name="pop">
              <div
                v-show="isShowNumberPop"
                @click="isShowNumberPop = false"
                class="parkingNumberPop"
                ref="parkingNumberPop"
              ></div>
            </transition>
          </div>
          <div
            v-if="isShowNumberIcon"
            @click="isShowNumberPop = !isShowNumberPop"
            class="item_icon"
          >
            <span class="icon-screening"></span>
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">车牌号</div>
          <div class="item_content">
            <Frame :license="orderObj.plateNumber"></Frame>
          </div>
          <div class="item_icon"></div>
        </div>
        <div class="order_item">
          <div class="item_label">车类型</div>
          <div class="item_content">
            {{ orderObj.vehicleType | vehicleTypeFilter }}
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">入场时间</div>
          <div class="item_content">
            {{ orderObj.enterTime | dateFilter_yy_MM_dd_hh_mm_ss }}
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">出场时间</div>
          <div class="item_content">
            {{ orderObj.leaveTime | dateFilter_yy_MM_dd_hh_mm_ss }}
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">停车时长</div>
          <div class="item_content">
            {{ orderObj.stayTime | timeTransformation }}
          </div>
        </div>

        <div class="order_item">
          <div class="item_label">订单金额</div>
          <div class="item_content">{{ orderObj.orderAmount }} 元</div>
          <div class="item_btn btn orderFlow-btn" @click="getOrderFlowInfo">
            查看订单流水
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">应收</div>
          <div class="item_content">{{ orderObj.payableAmount }} 元</div>
        </div>
        <div class="order_item">
          <div class="item_label">实收</div>
          <div class="item_content">{{ orderObj.payAmount }} 元</div>
        </div>
        <div
          class="order_item "
          v-if="
            ($condition.isOrderStatus_arrears(orderStatus) ||
              $condition.isOrderStatus_advance(orderStatus)) &&
              orderObj.id
          "
        >
          <div class="item_label">操作</div>
          <div class="order_item_btn">
            <div
              v-if="
                $condition.isOrderStatus_arrears(orderStatus) && orderObj.id
              "
              class="item_btn btn"
              @click="offlinePay(orderObj.id, stationId)"
            >
              线下支付
            </div>

            <div
              v-if="
                $condition.isOrderStatus_arrears(orderStatus) && orderObj.id
              "
              class="item_btn btn"
              :class="{ disabled: isPaying }"
              @click="onShowQRCode"
            >
              补 缴
            </div>

            <div
              v-if="
                $condition.isOrderStatus_advance(orderStatus) && orderObj.id
              "
              class="item_btn btn"
              @click="onRefund(orderObj.id)"
            >
              退 款
            </div>
          </div>
        </div>
        <div
          v-if="
            ($condition.isOrderStatus_success(orderStatus) ||
              $condition.isOrderStatus_advance(orderStatus)) &&
              orderObj.payWay
          "
          class="order_item"
        >
          <div class="item_label">支付方式</div>
          <div class="item_content">{{ orderObj.payWay | payWayFiler }}</div>
        </div>
        <div
          v-if="
            ($condition.isOrderStatus_success(orderStatus) ||
              $condition.isOrderStatus_advance(orderStatus)) &&
              orderObj.payTime
          "
          class="order_item"
        >
          <div class="item_label">支付时间</div>
          <div class="item_content">
            {{ orderObj.payTime | dateFilter_yy_MM_dd_hh_mm_ss }}
          </div>
        </div>
      </div>
    </div>

    <!-- 汽车图片展示图 -->
    <!--    <transition name="fade">-->
    <!--    <div v-show="showPic" class="order_pic" @click="showPic = false">-->
    <!--      <img :src="orderObj['vehiclePicture']" />-->
    <!--    </div>-->
    <!--  </transition>-->

    <div v-if="isPaying" class="paying_mask">
      <!-- 支付中展示页面 -->
      <div class="payLoading">
        <span>支付中</span>
        <span class="point point1_animation"></span>
        <span class="point point2_animation"></span>
        <span class="point point3_animation"></span>
      </div>
    </div>

    <!-- 二维码页面 -->
    <transition tag="div" name="pop">
      <qr-code
        v-show="showQRCode"
        @closeQRCode="closeQRCode"
        @failCallback="failCallback"
        @successCallback="successCallback"
        @onPay="onPay"
        :qrCodeInterFace="qrCodeInterFace"
        :showQRCode="showQRCode"
        :orderParkingId="orderObj.id"
        :stationId="stationId"
      ></qr-code>
    </transition>
  </div>
</template>

<script>
import scanPayMixin from "../../utils/scanPayMixin";
// import QRCode from "qrcodejs2";
import BScroll from "better-scroll";
import Frame from "../../components/Frame";
import {
  ORDER_PARKING_FIND_ORDER_PARKING_BY_ID,
  ORDER_PARKING_RECOVERY_SCANCODE_PAY,
  ORDER_PARKING_RECOVERY_QRCODE,
  ORDER_PARKING_OFFLINE_PAY,
  ORDER_PARKING_REFUND
} from "../../config/config";
import { Dialog, Toast } from "vant";
import conditionMethod from "../../utils/conditionMethod";
import JsBridge from "../../utils/JSBridge/JsBridge";
import qrCode from "../../components/QRCode";

export default {
  mixins: [scanPayMixin],

  data: () => ({
    //订单状态
    orderStatus: 15,

    //订单详细信息
    orderObj: {},

    //展示图片
    showPic: false,

    isPaying: false,

    count: 0,

    showQRCode: false,

    isRecovery: false,

    qrCodeInterFace: ORDER_PARKING_RECOVERY_QRCODE,

    parkingNumber: "",

    isShowNumberIcon: false,

    isShowNumberPop: false,

    stationId: null,
    filterLoading: false
  }),
  methods: {
    getOrderFlowInfo() {
      this.$utils.naviToOrderFlowList(this.orderParkingId);
    },

    onRefund(orderParkingId) {
      Dialog.confirm({
        title: "系统提示",
        message: "<span style='font-size : 20px ;'>是否确认退款</span>"
      }).then(() => {
        this.$utils.showLoading();

        this.$request(ORDER_PARKING_REFUND, { orderParkingId }, res => {
          this.$utils.closeLoading();
          this.pageInit();

          if (this.$condition.isRequestSuccess(res)) {
            Dialog.alert({
              title: "系统提示",
              message: "<span style='font-size : 20px ;'>退款成功</span>"
            });
          }
        });
      });
    },

    exceededPollingTimes() {
      this.$utils.goBack();
    },

    toResult(id) {
      if (id) {
        this.$utils.orderParkingId(id);
      } else {
        Toast("操作失败，请重试");
      }
    },

    //二维码失败回调
    failCallback() {
      this.$router.replace({
        name: "Result",
        params: {
          orderStatus: this.orderStatus,
          oid: this.orderObj.id,
          orderAmount: (
            this.orderObj.payableAmount - this.orderObj.payAmount
          ).toFixed(2),
          isRecovery: this.orderObj.isRecovery
        }
      });
    },

    successCallback() {
      this.$utils.goBack();
      this.$utils.orderParkingId(this.orderParkingId);
    },

    //关闭二维码页面
    closeQRCode() {
      this.showQRCode = false;
    },

    onShowQRCode() {
      this.qrCodeInterFace = ORDER_PARKING_RECOVERY_QRCODE;
      this.showQRCode = true;
    },

    offlinePay(orderParkingId, stationId) {
      Dialog.confirm({
        title: "系统提示",
        message:
          "<span style='font-size : 20px ;'>请确认是否完成线下支付</span>"
      })
        .then(() => {
          // this.$utils.getStationId((stationId) => {

          if (orderParkingId && stationId) {
            //请求数据
            this.$request(
              ORDER_PARKING_OFFLINE_PAY,
              { orderParkingId, stationId },
              res => {
                if (this.$condition.isRequestSuccess(res)) {
                  this.$utils.goBack();
                }
              }
            );
          }
          // });
        })
        .catch(() => {
          Dialog.close();
        });
    },

    pageInit() {
      let { orderParkingId, orderStatus } = this.$route.params;
      // vm.$utils.log(orderStatus, oid)

      this.$utils.getStationId(stationId => {
        this.stationId = stationId;
      });

      // let data = this.$route.query;

      // this.orderObj = data;

      this.orderStatus = orderStatus;

      //发起请求，获取订单信息
      this.$request(
        ORDER_PARKING_FIND_ORDER_PARKING_BY_ID,
        { orderParkingId },
        res => {
          this.$utils.closeLoading();

          let data = res["data"];
          //获取信息成功

          if (this.$condition.isRequestSuccess(res)) {
            //赋值
            for (let k in data) {
              this.$set(this.orderObj, k, data[k]);
            }

            // Dialog.alert({
            //   message: "stationId ==> " + JSON.stringify(this.orderObj),
            // });

            this.orderStatus = this.orderObj.orderStatus;

            this.parkingNumber = this.orderObj.parkingNumber;
            this.orderParkingId = this.orderObj.id;
            this.orderAmount = this.orderObj.orderAmount;
            this.isRecovery = this.orderObj.isRecovery;

            this.scanCodeInterface = ORDER_PARKING_RECOVERY_SCANCODE_PAY;
            //       // Toast(vm.orderObj.vehiclePicture)

            this.bscrollInit();
            this.filterLoading = false;
          }
        }
      );
    },

    bscrollInit() {
      //加载列表BScroll
      this.$nextTick(() => {
        if (!this.orderListBScroll) {
          this.orderListBScroll = new BScroll(this.$refs.orderList, {
            prototype: 2,
            click: true
          });
        } else {
          this.orderListBScroll.refresh();
        }
      });
    }
  },
  filters: {
    //根据值，返回车类型
    vehicleTypeFilter(type) {
      return conditionMethod.vehicleTypeTest(type);
    },

    payWayFiler(type) {
      return conditionMethod.payWayTest(type);
    }
  },
  computed: {
    orderTitle() {
      if (
        this.$condition.isOrderStatus_success(this.orderStatus) ||
        this.$condition.isOrderStatus_advance(this.orderStatus)
      ) {
        return "收费记录";
      } else if (this.$condition.isOrderStatus_arrears(this.orderStatus)) {
        return "欠费记录";
      } else if (this.$condition.isOrderStatus_abnormal(this.orderStatus)) {
        return "异常订单";
      }
      return "订单详情";
    }
  },
  watch: {
    parkingNumber(newV, oldV) {
      if (newV != oldV) {
        if (newV.indexOf(",") > 0) {
          let str = "";
          this.isShowNumberIcon = true;
          this.$refs.parkingNumber.innerHTML = newV.split(",")[0];
          newV.split(",").forEach(item => {
            str += `<span>${item}</span><br/>`;
          });
          this.$refs.parkingNumberPop.innerHTML = str;
        } else {
          this.$refs.parkingNumber.innerHTML = newV;
        }
      }
    }
  },
  components: {
    Frame,
    qrCode
  },
  mounted() {
    this.bscrollInit();

    JsBridge.registerHandler("showQRCode", () => {
      this.onShowQRCode();
    });
  },
  beforeDestroy() {
    //销毁BScroll
    if (this.orderListBScroll) {
      this.orderListBScroll.destroy();
    }

    //清楚定时器
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.payingTimeout) {
      clearTimeout(this.payingTimeout);
    }
    if (this.pollRequestTimeout) {
      clearTimeout(this.pollRequestTimeout);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      //调用改变顶部状态栏颜色
      vm.$utils.changeStatusBarStyle("black");
      vm.filterLoading = true;
      vm.$utils.showLoading();
      // vm.loading = true;
      // vm.setLoading(true);
      //oid：订单id   orderStatus：订单状态
      vm.pageInit();
    });
  }
};
</script>

<style lang="less" scoped>
.pop-enter-to,
.pop-leave {
  transform: translateY(0);
  opacity: 1;
}
.pop-enter,
.pop-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.pop-enter-active,
.pop-leave-active {
  transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.order_wrapper {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;

  &.native {
    padding-top: 26px;
  }

  .icon-left {
    font-size: 24px;
    margin-right: 6px;
    color: #333;
  }

  .nav_icon {
    font-size: 24px;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}

.order_box {
  width: 100%;
  height: calc(100% - 46px);
  padding: 0 18px;
  overflow: hidden;

  .order_list {
    width: 100%;
  }
}

.order_item {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  font-size: 20px;
  border-bottom: 1px solid rgba(7, 17, 27, 0.1);

  .item_label {
    flex: 0 0 100px;
    color: #000;
  }

  .item_content {
    flex: 1;
    color: #333;
    position: relative;

    .parkingNumberPop {
      position: absolute;
      left: 0;
      top: -10px;
      z-index: 51;
      background-color: #fff;
      padding: 8px 16px;
      font-size: 24px;
      border: 1px solid rgba(7, 17, 27, 0.1);
    }
  }

  .item_icon {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 28px;
  }

  .item_btn {
    font-size: 20px;
    padding: 6px 18px;
    border-radius: 4px;
    background-color: #1989fa;
    color: #fff;

    &.disabled {
      pointer-events: none;
    }
  }

  .order_item_btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.order_pic {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(7, 17, 27, 0.6);
  z-index: 50;

  > img {
    display: block;
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 51;
  width: 100%;
  height: 100%;
  background-color: rgba(7, 17, 27, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  .van-loading {
    color: #fff;
    font-size: 24px;
  }

  .van-loading__text {
    color: #fff;
  }
}

.paying_mask {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 52;
  background-color: rgba(7, 17, 27, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  .payLoading {
    margin: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    color: skyblue;

    .point {
      display: block;
      width: 10px;
      height: 10px;
      // border : 1PX solid #333 ;
      border-radius: 50%;
      margin-left: 10px;
    }

    .point1_animation {
      animation: point1 1s linear 0ms infinite;
    }

    .point2_animation {
      animation: point2 1s linear 0ms infinite;
    }

    .point3_animation {
      animation: point3 1s linear 0ms infinite;
    }

    @keyframes point1 {
      0% {
        background-color: #fff;
      }

      50% {
        background-color: skyblue;
      }

      100% {
        background-color: skyblue;
      }
    }

    @keyframes point2 {
      0% {
        background-color: skyblue;
      }

      50% {
        background-color: #fff;
      }

      100% {
        background-color: skyblue;
      }
    }

    @keyframes point3 {
      0% {
        background-color: skyblue;
      }

      50% {
        background-color: skyblue;
      }

      100% {
        background-color: #fff;
      }
    }
  }
}

.orderFlow-btn {
  font-size: 16px !important;
}
</style>
